import script from "./Inbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Inbox.vue?vue&type=script&setup=true&lang=js"

import "./Inbox.vue?vue&type=style&index=0&id=7f0e2b59&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0e2b59"]])

export default __exports__